/**
 * The AttributeReplacers return new names for some
 * attributes.
 */
const AttributeReplacers: Record<string, string> = {
  // Common html props
  class: 'className',
  colspan: 'colSpan',
  for: 'htmlFor',
  readonly: 'readOnly',
  autocomplete: 'autoComplete',

  // Chart button
  chartid: 'chartId',

  // Dynamic button
  apiaprops: 'apiaProps',

  // Profiles props

  // Users administration
  isglobal: 'isGlobal',
  iscreate: 'isCreate',
  ldapfull: 'ldapFull',
  passwordprops: 'passwordProps',

  // Validation fields
  initialvalue: 'initialValue',
  submitvalueparser: 'submitValueParser',
  validationclass: 'validationClass',
  validationfunction: 'validationFunction',
  validationrules: 'validationRules',
  allowpickbeforetoday: 'allowPickBeforeToday',
  evtmetafilters: 'evtMetaFilters',
  trafreemetafilters: 'traFreeMetaFilters',

  // Documents info modal
  allowdownload: 'allowDownload',

  // Documents upload modal
  allowpickfromdirectories: 'allowPickFromDirectories',
  allowpickfrommonitor: 'allowPickFromMonitor',

  // Document Info modal
  frommonitor: 'fromMonitor',
  showhistory: 'showHistory',
  showdownloadinfo: 'showDownloadInfo',
  showpermissions: 'showPermissions',
  // LangPicker
  currentlang: 'currentLang',

  // Change Dates Modal
  dateinputname: 'dateInputName',
  initiallyexpanded: 'initiallyExpanded',

  buttonsactions: 'buttonsActions',

  // Reports
  reportname: 'reportName',
};

export default AttributeReplacers;
